@if (messages$ | async; as messages) {
  <div data-test="global-messages--container">
    @for (assistiveMsg of messages[messageType.MSG_TYPE_ASSISTIVE]; track assistiveMsg.key) {
      <div class="cx-visually-hidden" [attr.data-test]="'global-messages--assistive-container-' + assistiveMsg.key">
        <span
          [attr.data-test]="'global-messages--assistive-message-' + assistiveMsg.key"
          [innerHTML]="assistiveMsg | cxTranslate"
          class="body-small content-message"
        ></span>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_INFO]; let i = $index; track infoMsg.key) {
      <div
        class="alert info-msg" [attr.data-test]="messageType.MSG_TYPE_INFO"
        [attr.data-test]="'global-messages--info-container-' + infoMsg.key"
      >
        <mat-icon svgIcon="help-solid" [attr.data-test]="'global-messages--info-icon-' + infoMsg.key" />
        <span
          [attr.data-test]="'global-messages--info-message-' + infoMsg.key"
          [innerHTML]="infoMsg | cxTranslate"
          class="body-small content-message"
        ></span>
        <button
          [attr.data-test]="'global-messages--info-close-btn-' + infoMsg.key"
          [attr.aria-label]="'common.close' | cxTranslate"
          class="close"
          type="button"
          (click)="clear(messageType.MSG_TYPE_INFO, i)"
        >
          <mat-icon svgIcon="close" />
        </button>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_WARNING]; let i = $index; track infoMsg.key) {
      <div class="alert warning-msg" [attr.data-test]="'global-messages--warning-container-' + infoMsg.key">
        <mat-icon svgIcon="warning" [attr.data-test]="'global-messages--warning-icon-' + infoMsg.key" />
        <span
          [attr.data-test]="'global-messages--warning-message-' + infoMsg.key"
          [innerHTML]="infoMsg | cxTranslate"
          class="body-small content-message"
        ></span>
        <button
          [attr.data-test]="'global-messages--warning-close-btn-' + infoMsg.key"
          class="close"
          type="button"
          (click)="clear(messageType.MSG_TYPE_WARNING, i)"
          [attr.aria-label]="'common.close' | cxTranslate"
        >
          <mat-icon svgIcon="close" />
        </button>
      </div>
    }
    @for (errorMsg of messages[messageType.MSG_TYPE_ERROR]; let i = $index; track errorMsg.key) {
      <div
        class="alert alert-danger" [attr.data-test]="messageType.MSG_TYPE_INFO"
        [attr.data-test]="'global-messages--warning-container-' + errorMsg.key"
      >
        <mat-icon svgIcon="alert-solid" [attr.data-test]="'global-messages--error-container-' + errorMsg.key" />
        <span
          [innerHTML]="errorMsg | cxTranslate" class="body-small content-message"
          [attr.data-test]="'global-messages--warning-message-' + errorMsg.key"
        ></span>
        <button
          [attr.data-test]="'global-messages--warning-close-btn-' + errorMsg.key"
          [attr.aria-label]="'common.close' | cxTranslate"
          class="close"
          type="button"
          (click)="clear(messageType.MSG_TYPE_ERROR, i)"
        >
          <mat-icon svgIcon="close" />
        </button>
      </div>
    }
  </div>

}
